import * as config from "config-api";

// URLs needing to be called through the cors hadder proxy https://stash.nm.cbc.ca/projects/NMSRC/repos/cors-hadder/browse
const PROXY = "https://www.cbc.ca/cors-hadder?url=";
const RADIO_URL =
    "https://www.cbc.ca/programguide/live.do?output=json&networkKey=cbc_radio_one";

export const API = {
    default: config.getString("Client.scheduleApi.sportsBaseURL"),
    sports: config.getString("Client.scheduleApi.sportsBaseURL"),
    radio: `${PROXY + encodeURIComponent(RADIO_URL)}`,
};
